// extracted by css-extract-rspack-plugin
export default {"root":"root-2alG_","label":"label-3C4Yo","default":"default-24nGF","error":"error-cDBF5","pinned":"pinned-1zj4_"};